"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedstore = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedstore` : '') + (description ? ` desc-brandedstore` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedstore"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedstore"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6 8h52v52H6V8Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M4 5c0-.55.48-1 1.08-1h53.84c.6 0 1.08.45 1.08 1v3H4V5Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6 44h52v16H6V44Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6 44h52v4H6v-4Z",
    fill: "#FFC599"
  }), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_11806_491)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.41 12.36v.1a4.83 4.83 0 0 0-2 3.96c0 2.86 4.28 5.96 10.5 5.96 2.15 0 4.24-.28 6.31-.94h.11c-1.72.94-4.03 1.7-6.8 1.7-6.2 0-10.53-2.82-10.53-6.63 0-1.68.9-3.06 2.41-4.15Zm8.43 7.19c.26 0 .43.1.43.3 0 .22-.2.3-.33.34h-.01c.13 0 .38.1.38.33 0 .28-.24.4-.5.4h-.52l.02-.55v-.27c0-.22 0-.38-.02-.55h.55Zm9.34 0c-.02.11-.03.4-.03.73 0 .45-.21.64-.62.64-.36 0-.63-.15-.63-.52v-.85h.33c-.02.23-.03.45-.03.68 0 .47.15.55.42.55.34 0 .36-.34.36-.7a9 9 0 0 0-.01-.53.67.67 0 0 0 .2 0Zm4.98 0 .31.58v.01l.04-.05c.11-.17.2-.35.29-.54h.2l-.26.45-.04.06-.15.27v.17c0 .14 0 .28.02.42h-.36l.03-.39v-.18l-.46-.8h.38Zm-8.45 0 .18.48.04.1c.12.3.24.6.34.79h-.35a8.19 8.19 0 0 0-.14-.4h-.47l-.14.4h-.2l.58-1.37h.16Zm-2.97 0h.41v.17h-.49v.4h.48v.16a6.57 6.57 0 0 0-.48-.01v.48l.49-.01v.18h-.81l.01-.55v-.82h.39Zm9.28 0v.17l-.38-.01v.66c0 .22 0 .37.02.55h-.35c.02-.18.02-.33.02-.55v-.66l-.4.01v-.17h1.09Zm-12.3.65h-.09v.57h.11c.12 0 .23-.1.23-.28 0-.2-.09-.3-.25-.3Zm5.87-.3-.2.51h.4a8.92 8.92 0 0 0-.2-.5Zm-5.85-.28h-.1l-.01.3v.2h.1c.06 0 .12-.02.17-.07a.25.25 0 0 0 .07-.18.22.22 0 0 0-.06-.18.2.2 0 0 0-.17-.07Zm-1.33-7.55-.03.48-.06 1.94v.13l-.04 1.86c-.02 1.17-.35 1.71-.99 2.13-.46.3-1.11.44-1.64.44-1.17 0-2.58-.38-2.79-1.93a5.34 5.34 0 0 1-.02-.53v-2.72c0-.5-.02-1.28-.05-1.8.44.04.88.04 1.32 0l-.03.77c-.02.49-.03 1.05-.03 1.63v1.08c0 1.47.03 1.82.3 2.2.29.4.81.6 1.5.6.79 0 1.41-.42 1.62-1.02.08-.22.13-.53.13-1.35 0-1.3 0-2.61-.09-3.9h.9ZM38.3 12c-.04.27-.04.55-.01.82-.58-.06-1.27-.07-1.94-.07l-.02 1.13v3.72c0 .46.02.92.07 1.37a8.67 8.67 0 0 0-1.38 0c.04-.76.1-1.53.1-2.3v-2.8c0-.38-.02-.73-.03-1.12h-.49c-.06 0-.55.01-1.01.04h-.06c-.16 0-.32.02-.45.03.04-.26.05-.53.03-.8.72.05 1.69.05 2.43.05h.15c.8 0 1.68-.02 2.6-.07Zm2.82.07a69.86 69.86 0 0 0 1.4 3.56l.7 1.64.07.13.02.07.06.13.61 1.37H42.5l-.4-1.1-.42-1.06a35 35 0 0 0-1.18-.01h-.09l-1.15.01c-.32.77-.63 1.6-.79 2.16-.3-.02-.6-.02-.9 0l1.13-2.57a50.82 50.82 0 0 0 1.79-4.33h.64Zm-9.9 0a90.6 90.6 0 0 0-.1 4.34l.02 1.9h1.42l.07-.01c.38-.01.76-.03 1-.07-.03.11-.04.61 0 .74l-.91-.03h-.13a26.3 26.3 0 0 0-2.76.03l.07-2.73v-1.8a47.61 47.61 0 0 0-.05-1.67v-.07l-.02-.63c.25.05 1.14.04 1.38 0Zm9.22 1.66-1 2.41 1.01.03h.08c.2 0 .46 0 .81-.03l-.9-2.41Zm2.8-1.73c.23 0 .4.2.4.44 0 .23-.18.42-.4.42.1 0 .18-.04.24-.1.07-.07.1-.17.1-.26 0-.2-.15-.36-.34-.36a.35.35 0 0 0-.34.36c0 .1.03.19.1.25.06.07.15.11.24.11-.23 0-.4-.2-.4-.43 0-.12.04-.22.11-.3a.4.4 0 0 1 .3-.13Zm-.03.22c.1 0 .15.04.15.14 0 .04 0 .07-.03.1a.1.1 0 0 1-.08.04l.13.22h-.08l-.12-.22h-.07v.22h-.07v-.5h.17Zm.01.07h-.12v.14h.08c.07 0 .13 0 .13-.07s-.04-.07-.09-.07Z",
    fill: "#F26B1C"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20 26h24v34H20V26Z",
    fill: "#DAFCFE"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M44 60V36.97a54.11 54.11 0 0 1-24 21.3V60h24Z",
    fill: "#8AE6EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M31 27h2v33h-2V27Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 60V26H20v34h2V28.13h20V60h2Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M43.74 26H20.26a1 1 0 0 0-.94.67L16 36h32l-3.32-9.33a1 1 0 0 0-.94-.67Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16 36h32v4H16v-4Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16 36h32v2H16v-2Z",
    fill: "#FFC599"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_11806_491"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "white",
    transform: "translate(19 12.001)",
    d: "M0 0h26v11.14H0z"
  }))));
};
var _default = exports.default = brandedstore;